<template>
  <v-card class="rounded-card card-shadow fill-height">
    <v-card-title class="font-weight-bold pl-5">
      Listagem de alertas de preço
    </v-card-title>
    <v-card-text class="text--primary">
      <div>
        <px-pendencias-lista-alertas
          :alertas="alertas" :loading="loading"
          :on-change-options="onChangeOptions"
          :options-list="optionsList"
          @update="onClickRefresh"/>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import paginationMixin from '@/mixins/pagination-mixin';
import AlertaPrecoService from '@/modules/marketplace/alertas-preco/alerta-preco-service';
import PendenciasListaAlertas from './PendenciasListaAlertas.vue';

export default {
  props: {
    dataMes: Object,
  },
  mixins: [paginationMixin],
  data() {
    return {
      alertas: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'createdIn',
        sortDesc: false,
      },
      loading: false,
      optionsList: {},
      query: '',
    };
  },
  methods: {
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getAlertas();
    },
    onClickRefresh() {
      this.getAlertas();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getAlertas() {
      this.loading = true;
      const {
        limit,
        offset,
      } = this.listOptions;
      this.listOptions.filter = this.query;

      return AlertaPrecoService.getList({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.alertas = response.data;
          this.$emit('loaded', this.alertas);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: {
    pxPendenciasListaAlertas: PendenciasListaAlertas,
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
  },
};
</script>
